<template>
  <div class="sertifikat">
    <div class="navbar">
      <div @click="$router.go(-1)">
        <back />
      </div>
      <div>Sertifikat</div>
    </div>

    <div class="body">
      <div class="loading" style="display: flex; justify-content: center; padding: 60px 0" v-if="isLoading">
        <loading />
      </div>
      <div v-else>
        <div v-for="item, index in data" :key="index">
          <p><b>{{ item.nama }}</b></p>
          <div class="sertifikat">
            <a :href="`https://psppcdn.com/e-sertifikat/?signature=${item.signature}`" target="_blank" rel="noopener noreferrer">
              <img :src="`https://psppcdn.com/e-sertifikat/?signature=${item.signature}`" :alt="item.nama" width="100%">
            </a>
          </div>
        </div> 

        <div v-if="data.length <= 0">
          <p style="text-align: center; padding: 80px 0;">Belum ada sertifikat</p>
        </div>
      </div>

       <div style="position: sticky; bottom: 0;background: #fff;" v-if="!isLoading">
          <button type="button" class="btn-primary" @click="requestSertifikat()">Request Sertifikat</button>
        </div>
    </div>
  </div>
</template>

<script>
import Back from "./icons/Back.vue";
import Loading from "./icons/Loading.vue";

import moment from "moment";

export default {
  name: "Sertifikat",
  components: {
    Back,
    Loading,
  },
  data() {
    return {
      data: [],
      isLoading: false
    };
  },
  methods: {
    moment,
    async load() {
      this.isLoading = true;

      const token = this.$store.state.settings.user.access_token;
      const r = fetch(`https://psppcdn.com/server/v1/sertifikat`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const res = await (await r).json();
      if (res.valid) {
        this.data = res.data;
      }

      this.isLoading = false;
    },
    requestSertifikat() {
      this.$router.push('/request-sertifikat');
    }
  },
  mounted() {
    this.load()
  },
};
</script>

<style scoped lang="scss">
.sertifikat {
  .navbar {
    background: #fff;
    color: #333;
    padding: 15px;
    font-weight: 600;
    display: grid;
    grid-template-columns: 40px 1fr;
    border-bottom: 1px solid #ccc;
  }

  .body {
    padding: 15px;
    min-height: 100vh;
  }

  .sertifikat {
    margin: 15px 0;
    border: 1px solid #ccc;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
}
</style>
